import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { type AdminRole } from '@avanta/shared/types/enterprises';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { EnterprisesService } from 'services/enterprises';
import { useEnterpriseId } from 'stores/user';

export const useFetchEnterpriseAdminsCount = (role?: AdminRole): UseQueryResult<number, Error> => {
  const enterpriseId = useEnterpriseId();

  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_ADMINS_COUNT, enterpriseId, role],
    queryFn: () => EnterprisesService.getCountAdminsByEnterprise(enterpriseId, role),
    select: response => response.data.count,
    enabled: Boolean(enterpriseId),
  });
};
